function promiseSerial<T>(funcs: (() => Promise<T>)[]): Promise<T[]> {
    return funcs.reduce(
        (promise, func) =>
            promise.then((result) =>
                // eslint-disable-next-line promise/no-nesting
                func().then(Array.prototype.concat.bind(result)),
            ),
        Promise.resolve([]),
    );
}
async function loadWithRetries<T>(
    func: () => Promise<T>,
    maxRetries: number,
    onRetry?: (attempt: number) => void,
) {
    let attempt = 0;
    while (true) {
        attempt += 1;

        try {
            return await func();
        } catch (error) {
            onRetry && onRetry(attempt);
            if (attempt === maxRetries) {
                throw error;
            }
        }
    }
}

export const asyncHelper = {
    async delay(time) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    },
    promiseSerial,
    loadWithRetries,
};
